import { render, staticRenderFns } from "./user_field_config.vue?vue&type=template&id=02197619&scoped=true"
import script from "./user_field_config.vue?vue&type=script&lang=js"
export * from "./user_field_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02197619",
  null
  
)

export default component.exports